<div class="widget-wrapper" [style.height]="data?.height">
    <div class="widget-header" *ngIf="data?.title">
        <span class="widget-title">{{ data.title }}</span>
    </div>

    <div #chartEl class="chart-container"></div>
</div>